export const MSJ_ERROR_EMAIL_AGE = 'The email is invalid';
